'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getPlatform;

var _isApp = require('./isApp');

var _isApp2 = _interopRequireDefault(_isApp);

var _isAndroid = require('./isAndroid');

var _isAndroid2 = _interopRequireDefault(_isAndroid);

var _isIOS = require('./isIOS');

var _isIOS2 = _interopRequireDefault(_isIOS);

var _isMiNiProgram = require('./isMiNiProgram');

var _isMiNiProgram2 = _interopRequireDefault(_isMiNiProgram);

var _isQuickApp = require('./isQuickApp');

var _isQuickApp2 = _interopRequireDefault(_isQuickApp);

var _isIpad = require('./isIpad');

var _isIpad2 = _interopRequireDefault(_isIpad);

var _isPc = require('./isPc');

var _isPc2 = _interopRequireDefault(_isPc);

var _parseQueryString = require('./parseQueryString');

var _parseQueryString2 = _interopRequireDefault(_parseQueryString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PC = 'web';
var WAP = 'wap';
var IOS = 'ios';
var IPAD = 'ios';
var ANDROID = 'android';
var MINIPROGRAM = 'xiaochengxu';
var KUAIYINGYONG = 'kuaiyingyong';

function getPlatform() {
    var fromUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;


    if (fromUrl) {
        var urlParams = (0, _parseQueryString2.default)();
        if (urlParams.platfrom) {
            return urlParams.platfrom;
        }
    }

    if (_isPc2.default) {
        return PC;
    }
    if (_isApp2.default) {
        if (_isIpad2.default) {
            return IPAD;
        }
        if (_isIOS2.default) {
            return IOS;
        }
        if (_isAndroid2.default) {
            return ANDROID;
        }
    } else if (_isMiNiProgram2.default) {
        return MINIPROGRAM;
    } else if (_isQuickApp2.default) {
        return KUAIYINGYONG;
    }
    return WAP;
}


//////////////////
// WEBPACK FOOTER
// ./~/@guazi-fe/components/build/client/utils/getPlatform.js
// module id = 1450
// module chunks = 1